import React from "react";
import { Modal } from "@/components/ui";
import { fmt, fmtDate } from "@/lib/formatters";
import { Package, ClipboardList } from "lucide-react";

export const ViewMaterialExpenseModal = ({ isOpen, onClose, expense }) => {
  if (!expense) return null;

  const Card = ({ label, v, fullWidth = false }) => (
    <div className={`bg-slate-50 rounded-lg p-3 ${fullWidth ? 'col-span-2' : ''}`}>
      <div className="text-[10px] text-slate-500 mb-0.5 uppercase font-bold tracking-wider opacity-70">
        {label}
      </div>
      <div className="text-xs font-semibold text-brand-dark">
        {v !== undefined && v !== null && v !== "" ? String(v) : "—"}
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Expense Details: #${expense.expenseId || "Unknown"}`} size="max-w-lg">
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3">
          <Card label="Project ID" v={expense.projectId} />
          <Card label="Customer Name" v={expense.clientName} />
          
          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <Package size={14} /> Material Details
            </label>
          </div>
          
          <Card label="Material Name" v={expense.materialName} fullWidth />
          <Card label="Category" v={expense.category} />
          <Card label="Supplier" v={expense.supplier} />
          <Card label="Quantity" v={expense.quantity} />
          <Card label="Rate" v={`₹${fmt(expense.rate)}`} />
          <Card label="Total Amount" v={`₹${fmt(expense.amount)}`} />

          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-brand-blue uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <ClipboardList size={14} /> Additional Info
            </label>
          </div>

          <Card label="Date" v={expense.date ? fmtDate(expense.date) : "—"} />
          <Card label="Invoice No" v={expense.invoiceNo} />
          <Card label="Status" v={expense.status ? expense.status.toUpperCase() : "—"} fullWidth />
        </div>
      </div>
    </Modal>
  );
};
